export default interface Log {
  category: LogEventCategory;
  event:
    | PlaybackEvents
    | AccountActionEvents
    | InteractionEvents
    | HardwareEvents
    | MetricEvents;
  data: object;
  timestamp?: Date;
  userId?: string;
}

export enum LogEventCategory {
  PLAYBACK_ACTION = "playback-action",
  INTERACTION = "interaction",
  ACCOUNT_ACTION = "account-action",
  HARDWARE = "hardware",
}

export enum PlaybackEvents {
  PLAYBACK_STARTED = "playback-started",
  PLAYBACK_PROGRESS = "playback-progress",
  PLAYBACK_FINISHED = "playback-finished",
  CASTING_CONNECTED = "casting-connected",
  CASTING_DISCONNECTED = "casting-disconnected",
}

export enum AccountActionEvents {
  LOGIN_WITH_PHONE = "login-with-phone",
  LOGIN_WITH_EMAIL = "login-with-email",
  TWO_FACTOR_AUTH = "two-factor-auth",
  AUTOPLAY_TOGGLED = "autoplay-toggled",
  PHONE_VALIDATION_REJECTED = "phone-validation-rejected",
  PHONE_VALIDATION_SUGGESTION_APPLIED = "phone-validation-suggestion-applied",
  // One per session clear/skip in AccountContext (#856 / WS-12): names which
  // logout() fired so the next lost-session case identifies its own cause.
  WEB_LOGOUT = "web-logout",
}

export enum HardwareEvents {
  CHROME_CAST_DETAILS = "chrome-cast-details",
}

export enum InteractionEvents {
  SEARCH = "search",
  VIDEO_SELECTED = "video-selected",
  PLAYLIST_SELECTED = "playlist-selected",
  CHANNEL_SELECTED = "channel-selected",
  FEATURED_VIDEO_SELECTED = "featured-video",
  NOTIFICATION_ICON_SELECTED = "notification-icon",
  NOTIFICATION_TAPPED_SELECTED = "notification-card-tapped",
  NAVIGATION = "navigation",
  LANDING_PAGE_SHOWN = "landing-shown",
  LANDING_PAGE_DISMISSED = "landing-dismissed",
}

export enum MetricEvents {
  LOGIN = "login",
  SIGN_UP = "sign_up",
  PURCHASE = "purchase",
  FREE_TRIAL = "free-trial",
  VIDEO_VIEW = "video_view",
  VIDEO_WATCHED = "video_watched",
  // One event per session on a browser that lacks script.noModule, i.e. one
  // that loaded the @vitejs/plugin-legacy es5 bundle. Legacy-bundle uptake
  // measurement for the keep/remove decision (#643 / #649).
  LEGACY_BROWSER = "legacy_browser",
}
